import BaseModelAPI from '../BaseModelAPI';

export default class CustomerList extends BaseModelAPI {

	static entity = 'customerlist'
	static entityName = 'customer';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
